import React from 'react'
import { Navigate } from 'react-router-dom'

const Vendor = () => {
    return <Navigate to="/Vendors/vendor" replace />
}

export default Vendor